import { useQuery } from "@tanstack/react-query";
import ordersClient from "../../../api/order";

const useOrderQuery = (orderId: string) => {
  return useQuery({
    queryKey: ["order", orderId],
    queryFn: () => ordersClient.getOrderById(orderId, true),
    enabled: !!orderId,
  });
};

export default useOrderQuery;
